<template>
  <card-block>
    <card-header>
      Вопросы и ответы
      <template v-slot:right>
        <router-link :to="{name: 'faq.create'}" v-if="can('module.faq.create')">
          Добавить вопрос
        </router-link>
      </template>
    </card-header>
    <card-body>
      <spinner-block v-model="progress">
        <div class="mb-3 row">
          <div class="col-12 col-md-2">
            <div class="small">Статус</div>
            <gui-select sm v-model="filter.active" @change="getList" :hilightOn="['all']">
              <option value="active">Активные</option>
              <option value="deactive">Не активные</option>
              <option value="all">Все</option>
            </gui-select>
          </div>
          <div class="col-12 col-md-3">
            <div class="small">Приложение</div>
            <gui-application-select sm v-model="filter.application_id" @change="getList" :hilightOn="['', undefined]"/>
          </div>
          <div class="col-12 col-md-2">
          </div>
          <div class="col-12 col-md-5">
            <div class="small">Поиск</div>
            <gui-search sm v-model="filter.search" @change="getList" :hilightOn="['', undefined]"/>
          </div>
        </div>
        <div v-if="data && data.data && data.data.length">
          <table class="table table-hover">
            <thead>
            <tr>
              <th class="pr-0" style="width: 1rem;"></th>
              <th>Вопрос</th>
              <th class="d-none d-md-table-cell">Есть у клиента</th>
              <th class="d-none d-md-table-cell">Есть у экипажа</th>
              <th class="d-none d-md-table-cell">Сортировка</th>
              <th class="text-right"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in data.data" :key="row.id">
              <th class="pr-0">
                <i class="fas fa-circle small"
                   :title="row.is_active ? 'Активен' : 'Неактивен'"
                   :class="row.is_active ? 'text-success' : 'text-danger'"></i>
              </th>
              <td class="limit-half_length">
                <router-link :to="{name: 'faq.detail', params: {id: row.id}}" class="main-link">
                  {{ row.question }}
                </router-link>
              </td>
              <td class="d-none d-md-table-cell">
                {{ row.applications.find(e => e.id === 1) ? '+' : '' }}
              </td>
              <td class="d-none d-md-table-cell">
                {{ row.applications.find(e => e.id === 2) ? '+' : '' }}
              </td>
              <td class="d-none d-md-table-cell">
                {{ row.sort ? row.sort : '—' }}
              </td>
              <td class="text-right">

              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info">Список пуст</div>
      </spinner-block>
      <gui-paginate :data="data" ref="paginate" @change="getList"/>
    </card-body>
  </card-block>
</template>

<script>

import GuiApplicationSelect from "@/components/Widget/GuiApplicationSelect";

export default {
  components: {GuiApplicationSelect},
  data: function () {
    return {
      data: null,
      progress: true,
      filter: {
        active: 'active',
        search: '',
        application_id: '',
      }
    }
  },
  props: {},
  computed: {},
  beforeMount() {
    this.filter = storageLoad('filter_' + this.$route.name, this.filter);
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {

      let v = _.clone(this.filter);
      v.search = '';
      storageSet('filter_' + this.$route.name, v);

      axiosGetValue('/api/admin/faq/list', {
            page: this.$refs.paginate.currentPage,
            per_page: this.$refs.paginate.perPage,
            filter: this.filter,
          },
          e => this.data = e, e => this.progress = e
      )
    }
  }
}
</script>